<template>
  <v-container class="flex-column d-flex h-100">
    <div class="tab-section-name">
      Профиль
    </div>
    <div class="d-flex overflow-auto column-wrapper flex-wrap">
      <v-col
        sm="12"
        md="6"
        xl="4"
        class="first-column"
      >
        <form class="d-flex flex-wrap flex-column">
          <div>
            <div class="label">
              Наименование
            </div>
            <v-text-field
              v-model="formData.title"
              v-validate="'required'"
              solo
              :error-messages="errors.collect('Наименование')"
              label="Наименование"
              data-vv-name="Наименование"
              required
            />
          </div>
          <div>
            <div class="label">
              ОКПО
            </div>
            <v-text-field
              v-model="formData.okpo"
              v-validate="'required|min:8|max:10|numeric'"
              solo
              disabled
              name="ОКПО"
              :error-messages="errors.collect('ОКПО')"
              label="ОКПО"
              data-vv-name="ОКПО"
              required
            />
          </div>
          <div>
            <div class="label">
              Email
            </div>
            <v-text-field
              v-model="formData.email"
              v-validate="'required'"
              solo
              name="Email"
              :error-messages="errors.collect('Email')"
              label="Email"
              data-vv-name="Email"
              required
            />
          </div>
          <div
            v-if="formData.phone"
            class="number-wrapper"
          >
<!--            <div class="label">-->
<!--              Телефон-->
<!--            </div>-->
<!--            <mobile-phone-->
<!--              :phone="formData.phone"-->
<!--              class="company-profile-phone"-->
<!--              @invalidPhone="phoneInvalid = true"-->
<!--              @changedPhone="changedPhone"-->
<!--            />-->
          </div>
        </form>
      </v-col>
    </div>
    <div
      class="flex-grow-1 align-end"
      style="display: flex;"
    >
      <v-btn
        v-if="loaded"
        class="ml-auto m-3 color-white flex-grow-0"
        color="#4caf50"
        @click="submit"
      >
        Сохранить
      </v-btn>
    </div>
  </v-container>
</template>

<script>
  import 'moment/locale/ru'
  // import MobilePhone from '../../../../../components/value-component/MobilePhone'

  export default {
    // components: { MobilePhone },
    props: {
      data: {
        type: Object,
      },
    },

    data () {
      return {
        formData: {
          title: '',
          okpo: '',
          phone: '',
          email: '',
          logo: '',
        },
        phoneInvalid: false,
        loading: false,
        items: [],
        search: null,
        select: null,
        loaded: true,
        title: 'Загрузить изображение',
        imageUrl: '',
        cropImage: '',
        imageFile: '',
        openImageCrop: false,
        isSnackbar: true,
      }
    },

    mounted () {
      this.$validator.localize('ru', this.dictionary)
    },

    created () {
      this.formData = Object.assign({}, this.data)
    },

    methods: {
      changedPhone (phone) {
        this.phoneInvalid = false
        this.formData.phone = phone
      },

      submit () {
        this.$validator.validateAll().then(validated => {
          if (!validated || this.phoneInvalid) {
            return
          }
          this.updateProfile()
        })
      },

      updateProfile () {
        // this.formData.logo = this.imageUrl
        this.$store.dispatch('companies/updateCompany', Object.assign({}, this.formData))
      },

      // // Жалкая попытка получить id компании
      // async getCompanyById (id) {
      //   const { data } = await this.companyRepository.getCompanyById(id)
      //   this.imageUrl = data.logo
      //     ? process.env.VUE_APP_API_URL + '/storage/' + data.logo
      //     : ''
      //   this.formData = data
      // },

      // Для поиска
      querySelections (v) {
        this.loading = true
        // Simulated ajax query
        setTimeout(() => {
          this.items = this.states.filter(e => {
            return (
              (e || '')
                .toLowerCase()
                .indexOf((v || '').toLowerCase()) > -1
            )
          })
          this.loading = false
        }, 500)
      },

      showModal () {
        this.openImageCrop = true
      },
      /**
       * Триггер события input'а при нажатии на аватарку.
       */
      pickFile () {
        this.$refs.image.click()
      },

      /**
       * Чтение файла.
       *
       * @param e event.
       */
      onFilePicked (e) {
        const files = e.target.files
        if (files[0] === undefined) {
          this.removeAvatar()
          return
        }

        let imageName = files[0].name
        if (imageName.lastIndexOf('.') <= 0) {
          return
        }

        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.cropImage = fr.result
          this.imageFile = files[0]
        })
      },

      /**
       * Закрыть модальное окно.
       */
      closeModal () {
        this.openImageCrop = false
        this.cropImage = ''
      },

      /**
       * Обновить изображение.
       *
       * @param imageUrl Изображение в формате base64.
       */
      updateImage ({ imageUrl }) {
        this.imageUrl = imageUrl
      },

      /**
       * Удалить изображение.
       */
      removeImage () {
        this.imageFile = ''
        this.imageUrl = ''
      },
    },
  }
</script>

<style scoped lang="scss">
  .label {
    font-weight: bold;
    text-align: left;
  }

  .padding {
    padding: 20px;
  }

  .v-input.company-search {
    margin-bottom: 28px;

    .v-input__control .v-input__slot {
      background-color: #fff !important;
    }
  }

  .column-wrapper {
    padding-left: 40px;
    padding-right: 40px;
  }

  .company-profile-phone {
    margin-bottom: 4px;
  }

  .profile-wrapper {
    padding-top: 37px;
  }

  i.v-icon.profile-photo.material-icons.theme--light {
    font-size: 70px;
  }

  .tab-section-name {
    width: 100%;
    color: #000;
    max-width: 250px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    white-space: normal;
    font-size: 20px;
    font-weight: 400;
    justify-content: flex-start;
    padding: 16px 16px 16px 50px;
  }
</style>
